document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
        const target = e.target.closest('.js-modalLightbox');
        if (!target) return;

        e.preventDefault();

        const getAttribute = (attr) => target.getAttribute(attr) || null;
        const modalId = getAttribute('data-modal-src');
        const form = document.querySelector(modalId);
        if (!form) return;

        const imgSrc = getAttribute('data-imgsrc');
        let imgAltTitle = getAttribute('data-imgalttitle');
        let messageContent = getAttribute('data-messagecontent');
        let customMessage = getAttribute('data-custommessage') || messageContent;
        let titleContent = getAttribute('data-titlecontent');
        const formCategory = getAttribute('data-formcategory');
        const formName = getAttribute('data-formname');
        const postTitle = getAttribute('data-posttitle');
        const requestedService = getAttribute('data-requestedservice');
        const requestedServiceDetail = getAttribute('data-requestedservicedetail');
        const specialtyEl = getAttribute('data-specialty');
        const hummingBird = getAttribute('data-hummingbird');
        const combinedData = getAttribute('data-combined-speciality');

        if (!formCategory || !postTitle) return;

        const formCategoryTitles = {
            Doctor: `Get Help Contacting ${postTitle}`,
            Center: `Get Help Contacting ${postTitle}`,
            ClinicalTrial: `<span class='c-contact__subtitle'>Get Help Enrolling in the</span> ${postTitle} Clinical Trial`,
            LawFirm: `Get Help Contacting ${postTitle}`
        };

        titleContent = formCategoryTitles[formCategory] || titleContent;
        if (formCategory === 'ClinicalTrial') {
            messageContent = `I would like to learn more about ${postTitle} and other clinical trials I may be qualified for.`;
        }

        const setElementContent = (selector, content, method = 'innerHTML') => {
            const elements = form.querySelectorAll(selector);
            elements.forEach(element => {
                if (element) element[method] = content;
            });
        };

        const setInputValue = (selector, value) => {
            const element = form.querySelector(selector);
            if (element) element.value = value;
        };

        setElementContent('.c-form__title, .js-formTitleMobile', titleContent);
        setElementContent('.js-specialtyContainer', specialtyEl, 'textContent');
        setElementContent('.js-combinedSpeciality', combinedData ? combinedData.split(',').map(data => `<span>${data.trim()}</span>`).join('') : '');
        setElementContent('.js-titleContainer', postTitle, 'textContent');
        setElementContent('.js-hummingbird', hummingBird, 'textContent');

        const diagnosisEl = form.querySelector("[name='diagnosis']");
        if (diagnosisEl && diagnosisEl.value && diagnosisEl.querySelector(`option[value='${diagnosisEl.value}']`)) {
            diagnosisEl.querySelector(`option[value='${diagnosisEl.value}']`).setAttribute('selected', 'selected');
        }

        setInputValue("input[name='requested_service']", requestedService);
        setInputValue("input[name='requested_service_detail']", requestedServiceDetail);
        setInputValue("input[name='ga_form_name']", formName);
        setInputValue("[name='comments']", customMessage);

        if (!imgAltTitle) imgAltTitle = postTitle;
        const imgEl = imgAltTitle && form.querySelector('.c-form__image');

        if (imgEl) {
            imgEl.setAttribute('title', imgAltTitle);
            imgEl.setAttribute('src', imgSrc);
            imgEl.setAttribute('alt', imgAltTitle);
        }
    });
});
